module.exports = __webpack_public_path__ + "static/g2_intro-ea1cec3c7346bc3b3b3a7c7ec49de3e7.jpg";